import { isIOS, isMobile } from "react-device-detect";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import { axiosInstance, BASE_URLS } from "@/src/shared/api";

const getUrlByDataStorageFile = async (payload: {
    uuid: string;
    fileName: string;
    sourceId: string;
}): Promise<string> => {
    const response = await axiosInstance.post(`${BASE_URLS.DATASTORAGE}/get`, {
        uuid: payload.uuid,
        originName: payload.fileName,
        sourceId: payload.sourceId,
    });
    if (response.data) {
        const fileData = new Uint8Array(response.data.data);
        const blob = new Blob([fileData], { type: "application/pdf" });
        return URL.createObjectURL(blob);
    }
    return "";
};

export async function downloadPolicy(policyPrintouts: any, contractNumber: string) {
    if (!policyPrintouts) return;

    if (isMobile && isIOS) {
        const zip = new JSZip();

        for (const payload of policyPrintouts) {
            const fileURL = await getUrlByDataStorageFile(payload);
            const response = await fetch(fileURL);
            const blob = await response.blob();
            zip.file(payload.fileName, blob); // Добавляем файл в архив
        }

        const zipBlob = await zip.generateAsync({ type: "blob" });
        saveAs(
            zipBlob,
            contractNumber ? `${contractNumber}.zip` : "policies.zip",
        );
    } else {
        for (const payload of policyPrintouts) {
            const fileURL = await getUrlByDataStorageFile(payload);

            const downloadLink = document.createElement("a");
            downloadLink.href = fileURL;
            downloadLink.download = payload.fileName;
            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
        }
    }
}